export function assetSrc(assetUrl: string) {
  if (import.meta.env.PROD) {
    // インライン化された場合は、CDN_HOSTを付けない
    if (assetUrl.startsWith('data:')) {
      return assetUrl // Return data URLs as is
    }
    if (import.meta.env.VITE_WIDGET_CDN_HOST) {
      const imageHost = import.meta.env.VITE_WIDGET_CDN_HOST as string
      return `${imageHost}${assetUrl}`
    }
  }
  return assetUrl
}
